export default __webpack_public_path__ + "static/media/button-disabled-empty-web-large.95615540.png";